import React from 'react';
import {AlreadyRegisteredScreenType} from '@practicegenius/register-account/src/screens/AlreadyRegistered';
import {BaseScreen} from '../../../components/screens/BaseScreen';
import {AlreadyRegisteredContent} from '../components/AlreadyRegisteredContent';

export const AlreadyRegistered: AlreadyRegisteredScreenType = ({
  lang,
  onPrimaryActionClick,
  ...otherProps
}) => (
  <BaseScreen
    helmetTitle={lang.pageTitle}
    headerTitle={lang.headerTitle}
    title={lang.title}
    actionButtons={[
      {
        children: lang.buttons.primary.title,
        onClick: onPrimaryActionClick,
        id: 'login_button',
        customWidth: 'extraWide',
        customHeight: 'tall',
        color: 'primary',
      },
    ]}
  >
    <AlreadyRegisteredContent lang={lang} {...otherProps} />
  </BaseScreen>
);
